import type { RescheduleFareDetailsErrorType } from '../../-api/reschedule';
import type { ErrorAction } from './index.types';

export const LOADER_DESCRIPTIONS = {
	'loading-cabs': [
		'We are checking availability with our cab partners',
		'Hang tight, almost there...',
	],
	processing: [
		'Initiating your reschedule request...',
		'Please wait while we confirm your booking',
	],
} as const;

export const RESCHEDULE_ERROR_CONFIG: Record<
	RescheduleFareDetailsErrorType,
	ErrorAction[]
> = {
	TECH_ERROR: [
		{ label: 'Get Help', variant: 'soft', handler: 'onGetHelp' },
		{ label: 'Try Again', variant: 'solid', handler: 'onTryAgain' },
	],
	WINDOW_CLOSE: [{ label: 'Get Help', variant: 'soft', handler: 'onGetHelp' }],
	NO_CABS: [{ label: 'Okay', variant: 'solid', handler: 'onClose' }],
	NOT_ELIGIBLE: [{ label: 'Okay', variant: 'solid', handler: 'onClose' }],
	TOO_MANY_ATTEMPTS: [{ label: 'Okay', variant: 'solid', handler: 'onClose' }],
};
